// extracted by mini-css-extract-plugin
module.exports = {"section":"about-us-module--section--2ogmA","title":"about-us-module--title--1dmS5","subtitle":"about-us-module--subtitle--1jgz5"};